export const common = {
  googleApiKey: 'AIzaSyD5W5mtLAJg0hfTO0CQVkz1OufjE0S-JwE',
  hereAppCredentials: {
    id: 'oln3Y4NphOg6F6yyYVZr',
    code: '3cQpa7bqIKItiAntw_LiIg',
  },
  endpoint: '/api',
};
